import translations from '../locales/en'

const translate = (text, returnNull = false) => {
  return translations[text] || returnNull ? null : text
}

export default {
  translate,
}
